import { render, staticRenderFns } from "./GenericRichTextInput.vue?vue&type=template&id=479b64a6&scoped=true"
import script from "./GenericRichTextInput.vue?vue&type=script&lang=ts"
export * from "./GenericRichTextInput.vue?vue&type=script&lang=ts"
import style0 from "./GenericRichTextInput.vue?vue&type=style&index=0&id=479b64a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b64a6",
  null
  
)

export default component.exports